import { Identify as AmplitudeIdentify } from '@amplitude/analytics-browser'

export default AmplitudeIdentify
